module.exports = __webpack_public_path__ + "img/angry.be5030ca.webp";